@if (!id) {
  <h2 class="mt-5 mb-4" i18n="Create post label">
  {{ "createMessage" | transloco }}
</h2>
}
@if (id) {
  <h2 class="mt-5 mb-4" i18n="Update post label">
  {{ "updateMessage" | transloco }}
</h2>
}
@if (post) {
  <div>
    <app-mail-form
      [editedMail]="post"
      (MailSubmit)="updatePost($event)"
    ></app-mail-form>
    <app-error-alert
      title="{{ 'postError' | transloco }}"
      i18n-title="Message post submit error alert"
      [errors]="submitErrors"
    ></app-error-alert>
  </div>
}
